// extracted by mini-css-extract-plugin
module.exports = {"container":"cookieModal_container__3IL3b","text":"cookieModal_text__dLxP4"};
    if(module.hot) {
      // 1790670235841
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  